import { useEffect, useState } from "react";
import "@/App.css";
import { HashRouter, Routes, Route } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import InstallBanner from "@/components/InstallBanner";
import Login from "@/pages/Login";
import CreateGlitch from "@/pages/CreateGlitch";
import StatusBoard from "@/pages/StatusBoard";
import ClosedToday from "@/pages/ClosedToday";
import GuestLog from "@/pages/GuestLog";
import Reports from "@/pages/Reports";
import Admin from "@/pages/Admin";
import { Toaster } from "@/components/ui/sonner";

function Shell({ children }) {
  const [hasBanner, setHasBanner] = useState(false);
  useEffect(() => {
    const check = () =>
      setHasBanner(
        !!document.querySelector('[data-testid="install-banner"]')
      );
    const t = setInterval(check, 500);
    return () => clearInterval(t);
  }, []);
  return <Layout hasBanner={hasBanner}>{children}</Layout>;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<ProtectedRoute page="new_glitch"><Shell><CreateGlitch /></Shell></ProtectedRoute>} />
      <Route path="/status" element={<ProtectedRoute page="status"><Shell><StatusBoard /></Shell></ProtectedRoute>} />
      <Route path="/closed" element={<ProtectedRoute page="closed"><Shell><ClosedToday /></Shell></ProtectedRoute>} />
      <Route path="/guest-log" element={<ProtectedRoute page="guest_log"><Shell><GuestLog /></Shell></ProtectedRoute>} />
      <Route path="/reports" element={<ProtectedRoute page="reports"><Shell><Reports /></Shell></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute adminOnly><Shell><Admin /></Shell></ProtectedRoute>} />
    </Routes>
  );
}

function App() {
  useEffect(() => {
    if ("serviceWorker" in navigator) {
      window.addEventListener("load", () => {
        const swUrl = new URL("sw.js", document.baseURI).href;
        navigator.serviceWorker.register(swUrl).catch(() => {});
      });
    }
  }, []);

  return (
    <div className="App">
      <HashRouter>
        <AuthProvider>
          <InstallBanner />
          <AppRoutes />
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </HashRouter>
    </div>
  );
}

export default App;
